import template from './vault.html';
import controller from './vault.controller';
import './vault.scss';

let vaultComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default vaultComponent;


// WEBPACK FOOTER //
// ./client/app/components/vault/vault.component.js